import { Component } from '@angular/core';
import { header } from './config/hospital-availability.config';
import { HospitalAvailabilityService } from '../../services/hospitalAvailability/hospitalAvailability.service';

@Component({
  selector: 'app-hospital-availability',
  templateUrl: './hospital-availability.component.html',
  styleUrl: './hospital-availability.component.scss'
})
export class HospitalAvailabilityComponent {
  constructor(private hospitalAvailabilityService: HospitalAvailabilityService) {}

  ngOnInit() {
    this.hospitalAvailabilityService.init();
  }

  getPageHeader(): string {
    return header;
  }
}
